import { FormControl, FormHelperText, FormLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';


export default function CustomSelect2({ values, onChange, error, data, title, required, disabled, placeholder, subtitle, marginTop, name, valueName, labelName, height, iconName, width }) {
    return (
        <>
            <FormControl variant="outlined" style={{ marginTop: marginTop || -2, width: width ? width : '-webkit-fill-available' }} fullwidth={width ? false : true} >
                {title && <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>}
                <Select
                    size="small"
                    value={values}
                    name={name}
                    required={required}
                    disabled={disabled}
                    disableUnderline
                    displayEmpty
                    placeholder={placeholder || 'Choose'}
                    onChange={(e) => onChange(e.target.value)}
                    style={{ color: (values === "" || values === "-1") && "#c8c8c8", height: height || 34, backgroundColor: 'white', borderRadius: 15, padding: 0, border: "1.5px solid #E9E9E9", fontWeight: 500, width: width }}
                    sx={{
                        '& .MuiFilledInput-input': {
                            borderRadius: 10,
                            backgroundColor: 'white',
                            padding: 0,
                            paddingInline: 2,
                        },
                         ".MuiOutlinedInput-notchedOutline": { border: 0 },
                        "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                        {
                            border: 0,
                        },
                        "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            border: 0,
                        },
                    }}
                    MenuProps={{
                        PaperProps: {
                            style: {
                                borderRadius: 10,
                                maxHeight: 250, // limit the height of the dropdown
                            },
                        },
                    }}
                    IconComponent={() => (
                        <i className={iconName || "ri-arrow-down-s-line mx-2"} style={{ zIndex: 2, color: "#c4c4c4" }} />
                    )}
                >
                    <MenuItem style={{ display: "none" }} key={"no-value"} value="-1" disabled>{placeholder}</MenuItem>
                    <MenuItem style={{ display: "none" }} key={"with-all-value"} value="all" disabled>{placeholder}</MenuItem>

                    {
                        data?.length > 0 ? data.map((x, idx) =>
                            <MenuItem key={idx}
                                value={x.value || x.id || x[`${valueName}`]}
                                style={{
                                    backgroundColor: (x.value || x.id) === values ? '#ED1A3D0D' : 'white',
                                    color: (x.value || x.id) === values ? '#ED1A3D' : '#101010'
                                }}
                            >
                                {x.label || x.name || x[`${labelName}`]}
                            </MenuItem>
                        ) :
                            <MenuItem disabled>No options available</MenuItem>
                    }
                </Select>
                <span style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{subtitle}</span>
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}

        </>


    );
}
